import React, { FC, useEffect, useRef, useState } from 'react'
import { Modal, Row, Table, Input, Col, Tabs, Timeline, Button,Image, Upload, notification, message } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { assetsListModel } from '../assetsListModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, getBaseImgLookUrl } from '@/utils/constants'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { assetsListService, IAssetsListDetail } from '../assetsListService'
import { ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { YhFormBox } from '@/components/YhFormBox'
import { ClockCircleOutlined, SmileOutlined, SyncOutlined } from '@ant-design/icons'
import { spawn } from 'child_process'
import { useDictModel } from '@/views/base/dict/dictModel'
import YhTootip from '@/components/YhTootip'
import { importPropsConfig } from '@/utils/importFile'
import { YhBut } from '@/components/YhButton'
import { globalPrompt } from '@/components/message'

const { Search } = Input

export const GoodsTransferModal = () => {
    const { getSelectedDictOne,getTreeNodeName } = useDictModel(() => []);
    const { goodsTransferVisible: visible, resetSearchParam,setGoodsTransferVisible,setGoodsList,goodsList,materialCodeRow,downloadTpl,exportUser} = assetsListModel()
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<IAssetsListDetail[]>([])
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const formRef = useRef<IYhFormRef>()
    const { setLoadingInfo,  } = useGlobalModel()

    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false, txt: '' })
        if (list && list.length) {
            let str = ''
            let newData: any = []
            list.map((object, index) => {
                if (object.status) {
                    console.log(object.details);
                    let item=object.details
                    // object.assetsDetails.map((item) => {
                    newData.push({
                        ...item,
                        temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
                    })
                    // })
                } else {
                    str += `【第${index + 1}条导入失败：${object.msg}】`
                }
            })
            setGoodsList((origin) => [...origin, ...newData])
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success('导入成功')
        }
    }
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '物资编码',
            width: 160,
            dataIndex: 'materialCode',
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
        },
        {
            title: '原始仓库',
            width: 160,
            dataIndex: 'originalWarehouseName',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '原始货位',
            width: 130,
            dataIndex: 'originalShelfCode',
            render: (text: string) =><YhTootip text={text} />,      
        },
        {
            title: '转移仓库',
            width: 160,
            dataIndex: 'warehouseName',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '转移货位',
            width: 160,
            dataIndex: 'shelfCode',
        },
        {
            title: '操作',
            width: 80,
            fixed: 'right',
            align: 'center',
            className: 'td-wrap',
            render: (text, record) => <YhBut type="delete" txt="" click={() => remove(record)} />
                
        },
    ]

    const remove = (record: any) => {
        setGoodsList((origin) => origin.filter((item) =>record.temporaryId? item.temporaryId !== record.temporaryId:item.id !== record.id))
    }


    const onOk = async () => {
        try {
			let { retData } = await assetsListService.goodsTransfer(goodsList);
			globalPrompt("message", { text: "转移成功！", type: "success" })
            setGoodsTransferVisible(false)
            resetSearchParam()
		} catch (error) {
            globalPrompt("message", { text: "转移失败！", type: "warning" })
			setGoodsTransferVisible(false)
            resetSearchParam()
		}
    }

    return (
        <Modal
            visible={visible}
            title="转移货位"
            onCancel={() => {
                setGoodsTransferVisible(false)
            }}
            onOk={onOk}
            width={1200}
        >
            <Button className="mr-5" type="link" shape="round" onClick={downloadTpl}>
            下载模板
        </Button>
        <Upload
            showUploadList={false}
            className="mr-10 ml-10"
            {...importPropsConfig(
                `/assets/assets/importTransferShelfDetails`,
                importCallback,
                () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中...' }),
                false
            )}
        >
            <Button className="mr-5" type="link" shape="round">
                导入
            </Button>
        </Upload>
            <Table
            style={{marginTop:20}}
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={goodsList}
                scroll={{ x: 'max-content' }}
                bordered
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showSizeChanger: true
                }}
            />
        </Modal>
    )
}
